/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const DidCommMessageBlobAttachmentStatus: core.serialization.ObjectSchema<
    serializers.DidCommMessageBlobAttachmentStatus.Raw,
    Truvity.DidCommMessageBlobAttachmentStatus
> = core.serialization.object({
    errorMessage: core.serialization.property('error_message', core.serialization.string().optional()),
    id: core.serialization.string(),
    mediaType: core.serialization.property('media_type', core.serialization.string()),
    status: core.serialization.string(),
});

export declare namespace DidCommMessageBlobAttachmentStatus {
    export interface Raw {
        error_message?: string | null;
        id: string;
        media_type: string;
        status: string;
    }
}
